module.exports = __webpack_public_path__ + "img/programme8.38dd2291.png";